export default [
    'zh-CN', 
    'en-US', 
    'zh-TW', 
    'ja-JP', 
    'tr-TR', 
    'vi-VN', 
    'th-TH',
    'de-DE',
    'pt-PT',
    'es-ES',
    'fr-FR',
    'it-IT',
    'in-ID',
    'ru-RU',
    'ar-AE',
    'ko-KR',
    'pl-PL',
    'ms-MY',
    'uz-UZ',
    'nl-NL',
    'sv-SE',
    'fi-FI',
    'da-DK',
    'nb-NO',
    'el-GR',
    'hu-HU',
    'bg-BG',
    'ro-RO',
    'cs-CZ',
    'sk-SK',
    'sl-SI',
    'sq-AL',
    'hr-HR',
    'lt-LT',
    'lv-LV',
    'et-EE',
    'is-IS',
    'km-KH',
    'lo-LA'
]